import React from 'react';
import { utils, writeFile } from 'xlsx';
import { AiOutlineDownload } from "react-icons/ai";

const ExcelTemplateDownloadButton = (props) => {
    const handleDownload = () => {
        const headers = ["Cuenta", "Debito", "Credito", "Descripcion", "Tercero"];
        const worksheetData = [headers];
        const worksheet = utils.aoa_to_sheet(worksheetData);
        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, "Plantilla");
        writeFile(workbook, "plantilla_comprobante.xlsx");
    };

    if (props.component) {
        return <props.component onClick={handleDownload}>{props.children || "Descargar plantilla"}</props.component>;
    }

    return (
        <button
            onClick={handleDownload}
            className="btn-excel-icon"
            title="Descargar Plantilla Excel"
        >
            <AiOutlineDownload size={16} />
        </button>
    );
};

export default ExcelTemplateDownloadButton;
